import ReactionItem from '../molecules/ReactionItem'
import {reactionsArray} from '../../helpers/data/reactions-data'
import uniqid from 'uniqid'

const ReactionPanel = () => {
  return (
    <div className="reaction-panel">
      {reactionsArray.map(reaction => (
        <ReactionItem key={uniqid()} type={reaction} isProud={reaction === 'PROUD'} />
      ))}
    </div>
  )
}

export default ReactionPanel
